// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2tbqN","label":"Completed_label__32a3-"};